<template>
  <div class="xtzbzhubo-wrapper">
    <div v-if="userInfo.cameraStatus !== 0" :id="videoContainerId" class="xtzbzhubo-video" style="object-fit: cover;"></div>
    <div v-else class="xtzbzhubo-bg">
      <img class="xtzbzhubo-bg-img" :src="userInfo.userInfo && userInfo.userInfo.headPortrait" alt="" />
    </div>
	<div class="xtzb-item-user">
	  <span class="xtzb-item-user-sort">1</span>
	  <span class="xtzb-item-user-name">主播</span>
	</div>
    <!-- <div class="xtzbzhubo-user" v-if="userInfo.userInfo">
      <span>{{userInfo.userInfo.nickName}}</span>
      <img
        v-if="userInfo.isPermitMicrophone == 1"
        class="xtzbzhubo-vioce"
        src="../../assets/image/zbj_lb_jy_2@2x.png"
        alt=""
        @click.stop="toggleMicrophone()"
      />
      <img
        v-if="userInfo.isPermitMicrophone == 0"
        class="xtzbzhubo-vioce"
        src="../../assets/image/zbj_lb_jy_3@2x.png"
        alt=""
        @click.stop="toggleMicrophone()"
      />
    </div> -->
  </div>
</template>

<script>
import { getChatRoomDetails, sendRefreshMsg } from "@/api/zhibo";
import { updateHelpLiveUser } from "@/api/zhubo";
export default {
  name: "xietongzhubo",
  props: {
    mainScreenData: {
      type: Object,
      default: null
    },
	liveId: {
	  type: String,
	  default: null
	}
  },
  data() {
    return {
      data: "",
      userInfo: {userInfo: {}},
      livePusher: null,
      audioEffectManager: null,
      videoContainerId: null,
      isDeviceReady: false,
      isPushing: false
    };
  },
  watch: {
    mainScreenData: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.userInfo = newVal;
          if (!this.isDeviceReady && newVal.cameraStatus !== 0) {
            this.getLivePusher();
          }
        }
      }
    }
  },
  mounted() {
    this.videoContainerId = "xtzbzhubo-container-" + Date.now();
    if (this.mainScreenData) {
      this.userInfo = this.mainScreenData;
      if (this.mainScreenData.cameraStatus !== 0) {
        this.$nextTick(() => {
          this.getLivePusher();
        });
      }
    }
  },
  beforeDestroy() {
    if (this.livePusher) {
      this.livePusher.stopCamera();
      this.livePusher.stopMicrophone();
      this.livePusher.stopPush();
      this.livePusher.destroy();
      this.livePusher = null;
    }
  },
  methods: {
    async getLivePusher(data) {
      const quality = data ? data : "720p";
      this.livePusher = new TXLivePusher();
      this.audioEffectManager = this.livePusher.getAudioEffectManager();
      this.livePusher.setVideoQuality(quality);
      this.livePusher.setAudioQuality("standard");
      this.livePusher.setProperty("setVideoFPS", 25);
      this.livePusher.setRenderView(this.videoContainerId);
      if (this.livePusher.videoView) {
        this.livePusher.videoView.muted = true;
      }

      this.livePusher.setObserver({
        onPushStatusUpdate: (code, message) => {
          console.log('推流状态更新:', code, message);
          if (code === 1001) {
            this.isPushing = false;
          } else if (code === 1002) {
            this.isPushing = true;
            console.log('推流真正成功了');
          } else if (code === -1307) {
            this.isPushing = false;
            console.error('推流连接断开');
          }
          if (code == 2) {
            this.sendRefreshMsg();
          }
        },
        onPushError: (code, message) => {
          console.error('推流错误:', code, message);
          this.isPushing = false;
        }
      });

      try {
        await this.livePusher.startCamera();
        await this.livePusher.startMicrophone();
        this.isDeviceReady = true;
        await this.getChatRoomDetails();
      } catch (error) {
        console.error("媒体设备启动失败:", error);
        this.isDeviceReady = false;
      }
    },
	async sendRefreshMsg(){
		const res = await sendRefreshMsg({liveId:this.liveId})
	},
    async startPush() {
      if (!this.isDeviceReady) {
        console.warn("设备未就绪，推流取消");
        return;
      }
      const pushUrl = this.data.chatRoomDetails ? this.data.chatRoomDetails.pushUrl : "";
      if (!pushUrl) {
        console.warn("推流地址为空");
        return;
      }
      const newUrl = pushUrl.replace(/^rtmp:\/\//, "webrtc://");
      try {
        await this.livePusher.startPush(newUrl);
      } catch (error) {
        if (error.message && error.message.includes("stream is pushing")) {
          console.warn("推流已在进行中");
        } else {
          console.error("推流发起失败:", error);
          this.isPushing = false;
        }
      }
    },
    async getChatRoomDetails() {
      if (!this.$route.query.liveId) {
        return;
      }
      const res = await getChatRoomDetails({ liveId: this.$route.query.liveId });
      this.data = res.data;
      this.startPush();
    },
    async toggleMicrophone() {
      if (!this.userInfo || !this.userInfo.helpId) return;
      const newStatus = this.userInfo.isPermitMicrophone === 1 ? 0 : 1;
      try {
        const res = await updateHelpLiveUser({
          helpId: this.userInfo.helpId,
          isPermitMicrophone: newStatus
        });
        this.$message.success(res.msg);
        this.userInfo.isPermitMicrophone = newStatus;
        if (this.livePusher) {
          if (newStatus === 1) {
            await this.livePusher.startMicrophone();
          } else {
            this.livePusher.stopMicrophone();
          }
        }
      } catch (error) {
        console.error("切换麦克风失败:", error);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.xtzbzhubo-wrapper {
  width: 100px;
  height: 100px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  background-color: #000;
  margin-right: 10px;
}

.xtzbzhubo-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 98;
}

.xtzbzhubo-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
}

.xtzbzhubo-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.xtzb-item-user{
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  z-index: 100;
}
.xtzb-item-user-sort{
	width: 14px;
	height: 14px;
	background: rgba(0,0,0,0.4);
	border-radius: 16px 16px 16px 16px;
	font-family: MiSans, MiSans;
	font-weight: 400;
	font-size: 9px;
	color: #FFFFFF;
	line-height: 14px;
	text-align: center;
}
.xtzb-item-user-name{
	font-family: MiSans, MiSans;
	font-weight: 400;
	font-size: 12px;
	color: #FFFFFF;
	margin-left: 4px;
}
</style>
<style>
.xtzbzhubo-video video {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}

.xtzbzhubo-video video::-webkit-media-controls {
  display: none !important;
}

.xtzbzhubo-video video::-webkit-media-controls-enclosure {
  display: none !important;
}

.xtzbzhubo-video video::-webkit-media-controls-panel {
  display: none !important;
}

.xtzbzhubo-wrapper button,
.xtzbzhubo-wrapper .vjs-big-play-button,
.xtzbzhubo-wrapper .tcp-big-play-button,
.xtzbzhubo-wrapper .vjs-control-bar {
  display: none !important;
  pointer-events: none !important;
}
</style>



// WEBPACK FOOTER //
// xietongzhubo.vue?009c94b2